import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from 'src/api';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';

import { LEARNING_OBJECT_QUERY_KEY } from './useGetLearningObjectsById';

interface UnenrollFromSessionVariables {
  courseId: string;
  enrollmentId: string; //full enrollment id in the format of course:123_456_789, where 123 is course id, 456 is instance id, and 789 is user id
}

export const useUnenrollFromSession = () => {
  const { user } = useAtlassianUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ enrollmentId }: UnenrollFromSessionVariables) => {
      if (!enrollmentId) {
        throw new Error('Enrollment id is required to unenroll from a session.');
      }
      if (!user?.email || !user.account_id) {
        throw new Error('User information is required to unenroll from a session.');
      }

      return apiClient.adobe.deleteEnrollment(enrollmentId, {
        email: user.email,
        aaid: user.account_id,
      });
    },
    onSuccess: async (_data, { courseId }) => {
      await queryClient.invalidateQueries({
        queryKey: [LEARNING_OBJECT_QUERY_KEY, courseId, user?.account_id],
      });
    },
  });
};


